<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/L22XtK/tc-custom/9781646568017.jpg?1718182736010" alt="This image is the cover for the book Sydney, One Way"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sydney, One Way
      </h1>
      <p class="bookDescription body article font2">
        <p>What’s that sound? Rain? The wind? Anna’s heart sinks when she realises it’s the shower running and Matilda’s no longer in bed. Today Matilda is leaving.<br/><br/>Bound for Sydney, Australia, Matilda’s starting the adventure of a lifetime. She’s planned it for years, long before she met Anna. Although a new relationship, Anna loves Matilda and the thought of never seeing her again is breaking her heart.<br/><br/>What should Anna do? Ask Matilda to stay? Or be selfless and let her go? Her head says one thing, her heart another.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mags Hayward
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?93d4fd34